<style scoped>
#search_filter {
	padding: 10px;
	min-height: 100%;
}

.search {
	background-color: white;
	border-radius: 4px;
	padding: 10px;
}

.spacer {
	height: 10px;
}
</style>

<template>
	<div id="search_filter">
		<v-alert type="error" v-if="errormsg != ''">{{
			errormsg
		}}</v-alert>

		<div class="text-center mb-1">
			<span>───</span>
			<span class="mx-3">Search Criteria</span>
			<span>───</span>
		</div>
		<v-form @submit.prevent="do_search">
			<div class="search">
				<v-select
					label="Assigned to"
					v-model="search.assign_mode"
					item-value="value"
					item-text="label"
					:items="[ { value: 0, label: 'you'}, { value: 1, label: 'your team'}, { value: 2, label: 'anyone'}]"	
					hide-details
				/>

				<div class="spacer" />

				<v-select
					label="Task status"
					v-model="search.statusses"
					:items="sorted_statusses"
					item-text="desc"
					item-value="id"
					multiple hide-details
					class="mb-2"
				>
					<template v-slot:selection="{ item, index }">
						<v-chip v-if="index <= 1">
							<span>{{ item.desc }}</span>
						</v-chip>
						<span
							v-if="index === 2"
							class="grey--text caption"
						>
							(+{{ search.statusses.length - 2 }} others)
						</span>
					</template>
				</v-select>

				<div class="spacer" />

				<v-select
					label="Date"
					v-model="search.date_mode"
					item-value="value"
					item-text="label"
					:items="[ { value: 0, label: 'today'}, { value: 1, label: 'next 7 days'}, { value: 2, label: 'date range'}]"
					hide-details
				/>

				<div class="spacer" v-if="search.date_mode == 2"/>

				<jb-date-picker
					v-if="search.date_mode == 2"
					label="Start date"
					v-model="start_date"
				/>

				<div class="spacer" v-if="search.date_mode == 2"/>

				<jb-date-picker
					v-if="search.date_mode == 2"
					label="End date"
					v-model="end_date"
				/>

				<div class="spacer" />

				<div class="text-center mb-1">
					<span>───</span>
					<span class="mx-3">Display</span>
					<span>───</span>
				</div>

				<v-select
					label="Group mode"
					v-model="search.group_mode"
					item-value="value"
					item-text="label"
					:items="[ { value: 0, label: 'not grouped'}, { value: 1, label: 'by day'}, { value: 2, label: 'by client'}, { value: 3, label: 'by job'}, { value: 4, label: 'by status' }]"
					hide-details
				/>
			</div>

			<div class="text-center mt-2">
				<v-btn color="primary" type="submit" class="text-capitalize">Search</v-btn>
			</div>
		</v-form>
	</div>
</template>

<script>
import { dateMixin } from "@/mixins/misc/dateMixin";
import jbdate from "@/components/controls/jbdate"

export default {
	mixins: [ dateMixin ],
	components: {
		'jb-date-picker': jbdate
	},
	model: {
		prop: "search",
		event: "on_change"
	},
	props: {
		meta: {
			type: Object,
			default: null
		},
		search: {
			type: Object,
			default() {
				return {
					assign_mode: 0,
					date_mode: 0,
					start_date: '',
					end_date: '',
					group_mode: 0,
				}
			}
		},
	},
	data() {
		return {
			errormsg: '',
			start_date: null,
			end_date: null,
		}
	},
	computed: {
		sorted_statusses() {
			let statusses = this.meta.statusses.filter(function(status) { return status.isactive });

			statusses.sort(function(a,b) {
				if (a.type < b.type) {
					return -1;
				} else if (a.type > b.type) {
					return 1;
				} else {
					return a.desc.toUpperCase() < b.desc.toUpperCase();
				}
			});

			return statusses;
		}
	},
	created() {
		if (this.search.start_date != '') {
			this.start_date = new Date(this.search.start_date);
		}
		if (this.search.end_date != '') {
			this.end_date = new Date(this.search.end_date);
		}
		this.check_statusses()
	},
	methods: {
		check_statusses() {
			if (this.meta == null) {
				// not yet ready to do this...
				return;
			}

			if (this.search.statusses.length == 0) {
				let statusses = [];
				let types = [2, 4];

				// console.log(groups);

				this.meta.statusses.forEach(function(status) {
					if (types.includes(status.type)) {
						statusses.push(status.id);
					}
				});

				this.search.statusses = statusses;
			}
		},
		do_on_change(new_val) {
			this.$emit('on_change', new_val)
		},
		do_search() {
			this.$emit('on_search')			
		},
	},
	watch: {
		meta: {
			deep: true,
			handler() {
				this.check_statusses();
			}
		},
		start_date() {
			let new_start_date = '';

			// save our entry
			if (this.start_date != null) {
				new_start_date = this.date_to_iso8601(this.start_date);				
			}

			if (this.search.start_date != new_start_date) {
				// only change if it changed or we'll start playing ping pong..
				this.search.start_date = new_start_date;
			}
		},
		end_date() {
			let new_end_date = '';

			// save our entry
			if (this.end_date != null) {
				new_end_date = this.date_to_iso8601(this.end_date);				
			}

			if (this.search.end_date != new_end_date) {
				// only change if it changed or we'll start playing ping pong..
				this.search.end_date = new_end_date;
			}
		},
		'search.start_date'() {
			let new_start_date = null;

			if (this.search.start_date != '') {
				new_start_date = new Date(this.search.start_date);
			}

			if (this.start_date != new_start_date) {
				// only change if it changed or we'll start playing ping pong..
				this.start_date = new_start_date;
			}
		},
		'search.end_date'() {
			let new_end_date = null;

			if (this.search.end_date != '') {
				new_end_date = new Date(this.search.end_date);
			}

			if (this.end_date != new_end_date) {
				// only change if it changed or we'll start playing ping pong..
				this.end_date = new_end_date;
			}
		}
	}
}

</script>
